import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Menu, Input, Row, Col, Button } from "antd";
import general from "../../../const/general";
import { Typography } from 'antd';
import SetParam from './SetParam';
import _ from 'lodash';
import admin from "../../../const/admin";

const ConfigurationTable = (props) => {

  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [selectedParam, setSelectedParam] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const formRef = useRef(null);

  useEffect(() => {
    setFilteredDataSource(props.dataSource);
  }, [props.dataSource]);

  // On narrow screens the form renders below the list: bring it into view when a parameter is chosen.
  const selectParam = (key) => {
    setSelectedParam(key);
    if (window.innerWidth < 768 && formRef.current)
      setTimeout(() => formRef.current && formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
  };


  const renderHeader = () => {
    return (
      <Input.Search className='mt-10 system-params-search'
        placeholder={general[props.language].search}
        onSearch={value => handleFilter(value)}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        enterButton
      />
    );
  };

  const handleFilter = (value = null) => {
    setSelectedParam(0);
    if (value) {
      setFilteredDataSource(_.without(_.map(props.dataSource, (o) => { if (o.name.toLowerCase().includes(value.toLowerCase())) { return o; } }), undefined));
    } else {
      return setFilteredDataSource(props.dataSource);
    }
  };

  const items = filteredDataSource.map((param, key) => { return { key: key, label: param.name, title: param.name } });
  return (
    <>
      <Button htmlType={'button'} type={'primary'} onClick={props.testSMTP}>{admin[props.language].testSMTP}</Button>
      <Row className='mt-10 system-params' style={{ border: '1px solid #E4E9F2' }}>
        <Col xs={24} md={8}>
          <Typography className='text-title color-black size18 mt-20 system-params-title'>{admin[props.language].system}</Typography>
          {renderHeader()}
          <Menu theme="dark" items={items} onClick={(evt) => selectParam(evt.key)}
            mode="vertical"
            defaultSelectedKeys={[0]}
            selectedKeys={[selectedParam]}
            className='mt-10 system-params-menu' />
        </Col>
        {selectedParam > -1 && filteredDataSource[selectedParam] ?
          <Col xs={24} md={16} ref={formRef}>
            <SetParam language={props.language} btn={general[props.language].edit} entry={filteredDataSource[selectedParam]} onSubmit={(formValues) => {
              setInputValue('');
              props.setConfigurationParam(formValues);
            }} />
          </Col>
          : null}
      </Row>
    </>

  );
};

export default ConfigurationTable;